import styled from 'styled-components';
import NextLink from 'next/link';
import { COLORS } from '~/src/styles/tokens/colors';

interface StyledLinkProps {
    linkcolor?: COLORS;
    textDecoration?: string;
}

export const Link = styled(NextLink)<StyledLinkProps>`
    text-decoration: none;
    cursor: pointer;
    color: ${(props) => (props.linkcolor ?? COLORS.constantDeepBlue)};

    &:hover {
        color: ${(props) => (props.linkcolor ?? COLORS.constantDarkBlueberry)};
        text-decoration: ${p => p.textDecoration};
        text-underline-position: under;
    }
`;
